"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingsRequestOrFilterBuilder = exports.ListingsRequestAndFilterBuilder = exports.ListingsRequestTextFilterBuilder = exports.ListingsRequestComparisonFilterBuilder = exports.ListingsRequestRangeFilterBuilder = void 0;
class BaseFilterBuilder {
    constructor(data) {
        this.data = data;
    }
    negated() {
        this.data.negated = true;
        return this;
    }
}
class ListingsRequestRangeFilterBuilder extends BaseFilterBuilder {
    constructor(key) {
        super({
            key,
            negated: false,
        });
    }
    min(n, exclusive = false) {
        if (this.data.minimum !== undefined) {
            throw new Error('Minimum value has already been set');
        }
        this.data.minimum = n;
        this.data.exclusiveMinimum = exclusive;
        return this;
    }
    max(n, exclusive = false) {
        if (this.data.maximum !== undefined) {
            throw new Error('Maximum value has already been set');
        }
        this.data.maximum = n;
        this.data.exclusiveMaximum = exclusive;
        return this;
    }
    build() {
        if (this.data.minimum === undefined && this.data.maximum === undefined) {
            throw new Error('At least one of minimum or maximum must be set');
        }
        if (this.data.minimum !== undefined &&
            this.data.maximum !== undefined &&
            this.data.minimum > this.data.maximum) {
            throw new Error('Minimum cannot be greater than maximum');
        }
        return Object.assign({}, this.data);
    }
}
exports.ListingsRequestRangeFilterBuilder = ListingsRequestRangeFilterBuilder;
class ListingsRequestComparisonFilterBuilder extends BaseFilterBuilder {
    constructor(key, compareTo, comparisonMode) {
        super({
            key,
            compareTo,
            comparisonMode,
            negated: false,
        });
    }
    build() {
        return Object.assign({}, this.data);
    }
}
exports.ListingsRequestComparisonFilterBuilder = ListingsRequestComparisonFilterBuilder;
class ListingsRequestTextFilterBuilder extends BaseFilterBuilder {
    constructor(key, text) {
        super({
            key,
            text,
            negated: false,
        });
    }
    build() {
        return Object.assign({}, this.data);
    }
}
exports.ListingsRequestTextFilterBuilder = ListingsRequestTextFilterBuilder;
class ListingsRequestAndFilterBuilder {
    constructor() {
        this.data = { and: [] };
    }
    filters(filters) {
        if (this.data.and.length) {
            throw new Error('filters have already been added to the AND filter');
        }
        this.data.and = filters;
        return this;
    }
    build() {
        if (this.data.and.length === 0) {
            throw new Error('At least one filter must be added to the AND filter');
        }
        return Object.assign({}, this.data);
    }
}
exports.ListingsRequestAndFilterBuilder = ListingsRequestAndFilterBuilder;
class ListingsRequestOrFilterBuilder {
    constructor() {
        this.data = { or: [] };
    }
    filters(filters) {
        if (this.data.or.length) {
            throw new Error('filters have already been added to the OR filter');
        }
        this.data.or = filters;
        return this;
    }
    build() {
        if (this.data.or.length === 0) {
            throw new Error('At least one filter must be added to the OR filter');
        }
        return Object.assign({}, this.data);
    }
}
exports.ListingsRequestOrFilterBuilder = ListingsRequestOrFilterBuilder;
